import PromoSlider from './slider';

export default class FactsSlider extends PromoSlider {
  private factButtons: HTMLElement[];

  private numberButtons: HTMLElement[];

  constructor(slider: string) {
    super(slider, false);
    this.factButtons = Array.from(document.querySelectorAll('.facts__fact-name'));
    this.numberButtons = Array.from(document.querySelectorAll('.facts__number'));
    this.initFactButtons();
    this.initNumberButtons();
  }

  private initFactButtons(): void {
    this.factButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.goToSlide(index);
        this.updateButtonsState(index);
      });
    });

    // Обновляем состояние кнопок при инициализации
    this.updateButtonsState(0);
  }

  private initNumberButtons(): void {
    this.numberButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.goToSlide(index);
        this.updateButtonsState(index);
      });
    });
  }

  protected goToSlide(index: number): void {
    super.goToSlide(index);
    this.updateButtonsState(index);
  }

  private updateButtonsState(activeIndex: number): void {
    // Обновляем состояние кнопок с названиями фактов
    this.factButtons.forEach((button, index) => {
      if (index === activeIndex) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });

    // Обновляем состояние кнопок с цифрами
    this.numberButtons.forEach((button, index) => {
      if (index === activeIndex) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }
}
